import { FormColorPicker } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Checkbox, Col, Form, Input, InputNumber, Row } from 'antd'

export const FormNomenclaturesTaskStatuses = () => {
  const { t } = useLocales()

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="name"
            label={t('nomenclature.name')}
            rules={[{ required: true }]}
          >
            <Input placeholder={t('generic.placeholder_input_here')} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="code"
            label={t('nomenclature.code')}
            rules={[{ required: true }]}
          >
            <Input placeholder={t('generic.placeholder_input_here')} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name="order"
            label={t('nomenclature.order')}
            rules={[{ required: true }]}
          >
            <InputNumber placeholder="1" min={1} />
          </Form.Item>
        </Col>

        <Col span={12}>
          <FormColorPicker
            itemProps={{
              label: t('nomenclature.color')
            }}
            showText
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="is_active"
            label={t('nomenclature.active')}
            initialValue={true}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
